<script>
  import {createEventDispatcher, onMount} from 'svelte';
  import {goto} from '@sapper/app';
  import {PATHS} from '@/const/paths';
  import {fixLink$} from '@/store/lang';
  import {resetSecurity$} from '@/store/reset-security';
  import VerifyCodeInput from '@/widgets/VerifyCodeInput.svelte';
  import {resetSecurityType$} from '@/modules/reset-security/stream';
  import errors from '@/modules/error/error.lang';
  import lang from '../GoogleVerification.lang';

  export let LG = null;
  export let verificationData = null;

  const dispatch = createEventDispatcher();

  let width = 1200;
  let status = '';
  let explain = '';
  let contextRef = null;
  let callbackRef = null;
  let googleCode = null;

  onMount(() => {
    status = '';
    explain = '';
    contextRef = verificationData.context;
    callbackRef = verificationData.callback;
  });

  function handleCodeChange(e) {
    googleCode = e.detail.value;
    status = 'loading';
    const callback = ({code, msg}) => {
      if (code === 34005 || code === 31005) {
        dispatch('close');
        return;
      }
      if (code === 0) {
        status = 'success';
        dispatch('close');
        return;
      }
      status = 'fail';
      const id = errors[code];
      explain = id ? LG(id) : msg;
    };
    callbackRef && callbackRef(googleCode, callback, contextRef);
  }

  function handleInputCode() {
    status = '';
    explain = '';
  }

  function handleClickReset() {
    resetSecurity$.set({email: contextRef.email, code: contextRef.code});
    resetSecurityType$.next({balanceType: 0, resetRecordId: 0, resetRecordStatus: 0, remain_count: 0, code: 0, answerStatus: 0});
    dispatch('close');
    goto($fixLink$(PATHS.RESET_SECURITY.pathname));
  }
</script>

<style>
  .warp {
    background: #fff;
  }
  .code :global(.digit-box) {
    margin: 0;
    border: 1px solid #dbdfe7 !important;
    border-radius: 8px;
    width: 60px;
    height: 72px;
  }
  .code :global(.digit-box.active) {
    border: 1px solid var(--blue) !important;
  }
  .code :global(.digit-box span) {
    font-weight: var(--fw2);
    font-size: 36px;
    color: var(--T1);
  }
  .code :global(.digit-box input) {
    padding: 0;
    width: 1px;
  }
  .code :global(.digit-box explain) {
    margin: 6px 0;
  }
  .btn {
    margin-top: 36px;
  }
  .btn :global(Button) {
    height: 50px;
  }
  @media screen and (min-width: 640px) {
    .main {
      border-radius: 8px;
      width: 480px;
      background: #fff;
    }
    .content {
      position: relative;
      display: flex;
      align-items: center;
      margin: 0 auto;
      height: 100%;
    }
  }
  .c-grey {
    color: #6C6E74;
  }
  .c-black {
    color: #1D2029;
  }
  @media screen and (max-width: 640px) {
    .title {
      text-align: left;
      font-size: 18px;
    }
    img {
      width: 106px;
      height: 24px;
    }
    .warp {
      background: #fff;
    }
    .content {
      padding: 0;
    }
    .main {
      margin: 0;
      padding: 24px 20px 40px;
    }
    .code :global(.digit-box) {
      width: 40px !important;
      height: 52px !important;
    }
    .code :global(.digit-box span) {
      line-height: 52px !important;
      font-size: 24px;
    }
  }
</style>

<div class="warp mt24" bind:offsetWidth={width}>
  <div class="content df fdc">
    <div class="main">
      <div class="title c-black lh36 f24 fw3">{LG(lang.GoogleVerification)}</div>
      <div class="title c-grey mt20 lh16 f12">{LG(lang.GoogleAuthenticator)}</div>
      <div class="code mt20">
        <VerifyCodeInput class="home-verification-code" {status} {explain} on:change={handleCodeChange} on:input={handleInputCode} />
      </div>
      <div class="mt20 f12 lh16 cp T1 fw3" on:click={handleClickReset}>{LG(lang.SecurityVerificationUnavailable)}</div>
    </div>
  </div>
</div>
